import * as Yup from "yup";
import { createNewMessageSerivce } from "../../services/ticketsServices.js";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import { convertObjectToFormdata } from "../../utils/convertObjectToFormdata.js";
import Alert from "../../utils/Alert.js";

export const initialValues = {
  context: "",
  file: "",
};

export const onSubmit = async (
  values,
  actions,
  ticketData,
  setContexts,
  setFileName,
  textareaContainerRef,
) => {
  const { file, ...data } = values;
  const finalData = convertObjectToFormdata(values.file ? values : data);
  try {
    const response = await createNewMessageSerivce(ticketData.code, finalData);
    if (response.status === 201 || response.status === 200) {
      const newContext = {
        ...response.data,
        date: convertDateToJalaali(response.data.sending_date, "jYYYY/jMM/jDD"),
        time: convertDateToJalaali(response.data.sending_date, "HH:mm"),
      };
      setContexts((prevContexts) => [...prevContexts, newContext]);
      actions.resetForm();
      setFileName("");
      textareaContainerRef.current.querySelector("[name='context']").focus();
    }
  } catch (error) {
    if (error.response.data.code === "TEXT_TOO_LONG") {
      Alert(
        `خطا ${error.response?.status || ""}!`,
        "امکان ارسال پیامک با متنی که بیش از ۶ فاصله داشته باشد وجود ندارد (منظور از فاصله همان space می‌باشد)",
        "error",
      );
    }
  } finally {
    actions.setSubmitting(false);
  }
};

export const validationSchema = Yup.object().shape({
  context: Yup.string().when("file", {
    is: "",
    then: (schema) =>
      schema
        .required("لطفاً متن  خود را بنویسید")
        .matches(/[^\s]+/, "لطفاً متن  خود را بنویسید"),
  }),
  file: Yup.mixed().test(
    "filesize",
    "حجم فایل حداکثر باید 5 مگابایت باشد",
    (value) => {
      return value ? value.size <= 5 * 1024 * 1024 : true;
    },
  ),
  // .test("format",
  //     "لطفاً فقط فایل تصویری یا متنی آپلود کنید.",
  //     (value) => {
  //         return value ? (value.type === "image/bmp" || value.type === "image/jpeg" || value.type === "image/x-png" || value.type === "image/png" || value.type === "text/plain") : true;
  //     })
});
